/**
 * Custom error that holds error code from backend response.
 * Useful to distinguish between Error and RequestError.
 */
export default class RequestError extends Error {
  constructor(errorCode, details, message) {
    super(message);

    // because we are extending a built-in class
    // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, RequestError.prototype);
    this.errorCode = errorCode;
    this.fieldErrors = details || {};
  }
}